import { motion } from "framer-motion";

// Default bursts tuned for the featured-donut stage.
const DONUT_BURSTS = [
  { x: "16%", y: "20%", color: "#e63946", delay: 0 },
  { x: "80%", y: "16%", color: "#2f57c9", delay: 0.7 },
  { x: "24%", y: "78%", color: "#f7f7f7", delay: 1.4 },
  { x: "84%", y: "72%", color: "#e63946", delay: 2.1 },
  { x: "52%", y: "8%", color: "#2f57c9", delay: 2.8 },
];

// Subtle red / white / blue fireworks. Reusable — pass custom bursts/config.
export const Fireworks = ({
  bursts = DONUT_BURSTS,
  radius = 48,
  particles = 11,
  particleSize = 5,
  peakOpacity = 0.55,
  flash = false,
  className = "z-0",
  testId = "donut-fireworks",
}) => (
  <div
    data-testid={testId}
    className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}
    aria-hidden="true"
  >
    {bursts.map((b, bi) => (
      <div key={bi} className="absolute" style={{ left: b.x, top: b.y }}>
        {flash && (
          <motion.span
            className="absolute rounded-full -translate-x-1/2 -translate-y-1/2"
            style={{
              width: particleSize * 3,
              height: particleSize * 3,
              background: b.color,
              filter: "blur(2px)",
            }}
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: [0, 1.7, 0], opacity: [peakOpacity + 0.2, peakOpacity, 0] }}
            transition={{
              duration: 1.3,
              ease: "easeOut",
              repeat: Infinity,
              repeatDelay: 2.6,
              delay: b.delay,
            }}
          />
        )}
        {Array.from({ length: particles }).map((_, i) => {
          const ang = (i / particles) * Math.PI * 2;
          const dx = Math.cos(ang) * radius;
          const dy = Math.sin(ang) * radius;
          return (
            <motion.span
              key={i}
              className="absolute rounded-full"
              style={{
                width: particleSize,
                height: particleSize,
                background: b.color,
                boxShadow: `0 0 ${particleSize + 3}px ${b.color}`,
              }}
              initial={{ x: 0, y: 0, opacity: 0, scale: 0.4 }}
              animate={{
                x: [0, dx, dx],
                y: [0, dy, dy + radius * 0.18],
                opacity: [0, peakOpacity, 0],
                scale: [0.4, 1, 0.4],
              }}
              transition={{
                duration: 1.3,
                ease: "easeOut",
                repeat: Infinity,
                repeatDelay: 2.6,
                delay: b.delay,
              }}
            />
          );
        })}
      </div>
    ))}
  </div>
);
